module.exports = __webpack_public_path__ + "img/icon-white-14.4615a490.svg";